import React from "react";

export default function Activityindicator() {
  return (
    <button
      type="submit"
        className="  font-[istok] w-full py-4 px-4 bg-[#D4F5F9] rounded-md  focus:outline-none focus:ring-2 focus:ring-black text-red-500"
                            >
      Loading..
    </button>
  );
}